import { t } from "../helpers/userHelper";
import { dictionary } from "../untils/dictionary";

export interface ITableHeaderProps {
  name: string;
  valueSource: string;
  sort?: boolean;
  date?: boolean;
  scope?: any;
  isCount?: boolean;
}

export const invoiceListHeader: ITableHeaderProps[] = [
  {
    name: t(dictionary.invoiceNumber),
    valueSource: "number",
  },
  {
    name: t(dictionary.date),
    valueSource: "created",
    date: true,
  },
  {
    name: t(dictionary.price),
    valueSource: "price",
  },
];

